import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Image, LI } from '../../../../AbstractElements';
import { Defaultitem1, Defaultitem2, Defaultitem3, Defaultitem5, WithImages } from '../../../../Constant';
import HeaderCard from '../../../Common/HeaderCard';

const WithImage = () => {
  return (
    <Col sm='6' xl='6'>
      <Card>
        <HeaderCard title={WithImages} />
        <CardBody>
          <div className='list-group default-list'>
            <LI className='list-group-item-action' tag='a' href='#javascript'>
              <Image className='media-body' body={true} src={require('../../../../assets/images/user/1.jpg')} alt='' />
              {Defaultitem1}
            </LI>
            <LI className='list-group-item-action' tag='a' href='#javascript'>
              <Image body={true} src={require('../../../../assets/images/user/1.jpg')} alt='' />
              {Defaultitem2}
            </LI>
            <LI className='list-group-item-action' tag='a' href='#javascript'>
              <Image body={true} src={require('../../../../assets/images/user/1.jpg')} alt='' />
              {Defaultitem3}
            </LI>
            <LI className='list-group-item-action disabled'>
              <Image body={true} src={require('../../../../assets/images/user/1.jpg')} alt='' />
              {Defaultitem5}
            </LI>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default WithImage;
